const sizeConfigs = {
  sidebar: {
    width: "224px"
  }
};

export default sizeConfigs;